import SEGMENT_TRACKING_EVENTS from 'constants/segmentEvents';

function TablelistNotEnabledBannerCtrl($scope, supportService, TRACKING_EVENT_CATEGORIES) {
  _initScope();

  function _initScope() {
    $scope.enableTablelistVenue = _enableTablelistVenue;

    //enums
    $scope.TRACKING_EVENT_CATEGORIES = TRACKING_EVENT_CATEGORIES;
    $scope.SEGMENT_TRACKING_EVENTS = SEGMENT_TRACKING_EVENTS;
  }

  function _enableTablelistVenue() {
    supportService.showNewMessage('Send us a message and we will get you setup on Tablelist!');
  }
}

TablelistNotEnabledBannerCtrl.$inject = [
  '$scope',
  'supportService',
  'TRACKING_EVENT_CATEGORIES'
];

export default TablelistNotEnabledBannerCtrl;



// WEBPACK FOOTER //
// ./src/directives/tablelistNotEnabledBanner/controller.js